/*
 * Ultra Estética — Add-ons de carrito
 * Agrega o quita la capacitación y la garantía extendida desde el carrito.
 * Depende de: snippets/ue-addons.liquid y assets/ue-addons.css
 */
(function () {
  'use strict';

  if (window.__ueAddonsLoaded) return;
  window.__ueAddonsLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_JS = ROOT + 'cart.js';
  var ADD_JS = ROOT + 'cart/add.js';
  var CHANGE_JS = ROOT + 'cart/change.js';

  var busy = false;
  var autoRemoving = {};

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ue-addons]'));
  }

  function rows(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-ue-addon]'));
  }

  function variantIdOf(row) {
    return parseInt(row.getAttribute('data-variant-id'), 10);
  }

  function getCart() {
    return fetch(CART_JS, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json();
    });
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && (data.description || data.message)) || 'cart error');
        return data;
      });
    });
  }

  function addItem(variantId) {
    return post(ADD_JS, { items: [{ id: variantId, quantity: 1 }] });
  }

  function setQuantity(variantId, quantity) {
    return post(CHANGE_JS, { id: String(variantId), quantity: quantity });
  }

  function hasDrawer() {
    return !!document.querySelector('[data-cart-drawer]');
  }

  /* En página de carrito recargamos (el tema recalcula totales solo).
     Con cajón lateral avisamos al tema para que refresque su contenido. */
  function refresh() {
    if (hasDrawer()) {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      getCart().then(sync).catch(function () {});
    } else {
      window.location.reload();
    }
  }

  function sync(cart) {
    roots().forEach(function (root) {
      var all = rows(root);
      var addonIds = all.map(variantIdOf);
      var threshold = parseInt(root.getAttribute('data-threshold'), 10) * 100;
      var realItems = cart.items.filter(function (item) {
        return addonIds.indexOf(item.variant_id) === -1;
      });
      var eligible = realItems.some(function (item) {
        return item.price >= threshold;
      });
      var visible = 0;

      all.forEach(function (row) {
        var variantId = variantIdOf(row);
        var needsThreshold = row.getAttribute('data-requires-threshold') === 'true';
        var inCart = cart.items.some(function (item) {
          return item.variant_id === variantId;
        });
        var show = realItems.length > 0 && (!needsThreshold || eligible);

        row.hidden = !show;
        if (show) visible++;

        var checkbox = row.querySelector('[data-ue-addon-checkbox]');
        if (checkbox) {
          checkbox.checked = inCart;
          checkbox.disabled = false;
        }

        /* El equipo que habilitaba el add-on ya no está en el carrito: lo sacamos. */
        if (!show && inCart && !autoRemoving[variantId]) {
          autoRemoving[variantId] = true;
          setQuantity(variantId, 0)
            .then(function () {
              autoRemoving[variantId] = false;
              refresh();
            })
            .catch(function () {
              autoRemoving[variantId] = false;
            });
        }
      });

      root.hidden = visible === 0;
    });
  }

  function setBusy(root, state) {
    busy = state;
    root.classList.toggle('ue-addons--busy', state);
    rows(root).forEach(function (row) {
      var checkbox = row.querySelector('[data-ue-addon-checkbox]');
      if (checkbox) checkbox.disabled = state;
    });
  }

  function showError(root, message) {
    var box = root.querySelector('[data-ue-addon-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  }

  function onChange(event) {
    var checkbox = event.target && event.target.closest
      ? event.target.closest('[data-ue-addon-checkbox]')
      : null;
    if (!checkbox || busy) return;

    var root = checkbox.closest('[data-ue-addons]');
    var row = checkbox.closest('[data-ue-addon]');
    if (!root || !row) return;

    var variantId = variantIdOf(row);
    var wanted = checkbox.checked;

    showError(root, '');
    setBusy(root, true);

    (wanted ? addItem(variantId) : setQuantity(variantId, 0))
      .then(function () {
        refresh();
      })
      .catch(function (error) {
        checkbox.checked = !wanted;
        setBusy(root, false);
        showError(root, 'No pudimos actualizar el carrito. Vuelve a intentarlo.');
        if (window.console) console.warn('[ue-addons]', error);
      });
  }

  function init() {
    if (!document.querySelector('[data-ue-addons]')) return;
    getCart().then(sync).catch(function () {});
  }

  document.addEventListener('change', onChange);
  document.addEventListener('theme:cart:loaded', init);
  document.addEventListener('theme:cart:open', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
